import Vue from 'vue';
import Vuex from 'vuex';

import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import {getAuthInfo} from '../utils/auth';

Vue.use(Vuex);

const jwt = getAuthInfo() || {};

const state = {
  sidebarVisible: false,
  token: jwt.access_token,
  user: {
    name: jwt.preferred_username || '用户名',
    sp_id: jwt.sp_id,
    sp_name: jwt.sp_name || '服务商名称',
    avatar: jwt.avatar
  },
  report: {
    loading: false,
    saving: false,
    form_html: '',
    common_fault_loading: false,
    common_fault: []
  },
  report_query: {
    querying: false,
    can_report_directly: true
  },
  report_list: {
    loading: false,
    columns: [],
    data: [],
    total: 0,
    additional_parameters: {}
  },
  report_detail: {
    loading: false,
    ticket: null,
    no: '',
    videos: [],
    voices: [],
    attachments: [],
    service_ticket: null,
    service_ticket_loaded: false,
  },
  report_steps: {
    querying: false,
    steps: [],
    current: 0
  },
  info: {
    saving: false,
    loading: false,
    user_name: '',
    is_verified: false
  },
  company_info: {
    name: '',
    cus_dept: '',
    link_man: ''
  }
};

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions
});



// WEBPACK FOOTER //
// ./src/store/index.js